import React, { useEffect } from "react";
import Posts from "./Posts/Posts";
import { useParams, useSearchParams } from "react-router-dom";

const ContentSearch = () => {
    const params = useParams<{ theme: string; backgroundColor: string; param: string, postIds: string, isDiscovery: string }>();
    const [searchParams] = useSearchParams();
    // Get query parameters from URL
    const theme = searchParams.get('theme') || params.theme;
    const isDiscovery = searchParams.get('isDiscovery') || params.isDiscovery;
    const postIds = searchParams.get('postIds') || params.postIds;
    const backgroundColor = searchParams.get('backgroundColor') || params.backgroundColor;
    const param = searchParams.get('param') || params.param;
    return (
        <Posts postIds={postIds ? postIds.split(',') : undefined} backgroundColor={backgroundColor} isDiscovery={isDiscovery ? true : false} theme={theme === 'dark' ? 'dark' : 'light'} />
    );
};

export default ContentSearch;
